export default "__VITE_ASSET__D5GmYevD__"